export function insert(string, what, index) {
    return index > 0
        ? string.replace(new RegExp('.{' + index + '}'), '$&' + what)
        : what + string;
}

export function formatTelMask(phone) {
    phone = insert(phone, '  ', 3);
    phone = insert(phone, '  ', 8);
    return phone;
}

export function formatTelMaskUK(phone) {
    phone = insert(phone, '  ', 4);
    phone = insert(phone, '  ', 9);
    return phone;
}


// WEBPACK FOOTER //
// ./src/utils/formatTelMask.js